{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description}}
{{/if}}
<button title="{{ config.description }}" class="fb-launch-button btn-tool tool-button">Edit Form Fields</button>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
